export function safeArray(prop) {
  if (Array.isArray(prop)) {
    return prop;
  } else {
    return [];
  }
}

export function safeString(prop, fallback = "") {
  if (typeof prop === "string") {
    return prop;
  } else {
    return fallback;
  }
}

export function safeNumber(prop, fallback = 0) {
  if (typeof prop === "number" && !isNaN(prop)) {
    return prop;
  } else {
    return fallback;
  }
}

export function safeObject(prop, fallback = {}) {
  if (prop !== null && typeof prop === "object" && !Array.isArray(prop)) {
    return prop;
  }
  return fallback;
}

export const cleanObject = (obj, empties = [null, undefined, ""]) => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => {
        if (empties.includes(value)) return false;
        if (Array.isArray(value))
          return !empties.includes("[]") || value.length > 0;
        if (typeof value === "object") {
          const cleaned = cleanObject(value, empties);
          return !empties.includes("{}") || Object.keys(cleaned).length > 0;
        }
        return true;
      })
      .map(([key, value]) => [
        key,
        typeof value === "object" && !Array.isArray(value)
          ? cleanObject(value, empties)
          : value,
      ]),
  );
};

// export function safeArray<T>(prop: unknown): T[] {
//   if (Array.isArray(prop)) {
//     return prop as T[];
//   } else {
//     return [] as T[];
//   }
// }

// export function safeString(prop: unknown, fallback = ""): string {
//   if (typeof prop === "string") {
//     return prop;
//   } else {
//     return fallback;
//   }
// }

// export function safeNumber(prop: unknown, fallback = 0): number {
//   if (typeof prop === "number" && !isNaN(prop)) {
//     return prop;
//   } else {
//     return fallback;
//   }
// }

// export function safeObject<T extends object>(
//   prop: unknown,
//   fallback = {} as T
// ): T {
//   if (prop !== null && typeof prop === "object" && !Array.isArray(prop)) {
//     return prop as T;
//   }
//   return fallback;
// }
